export default __webpack_public_path__ + "static/media/NadineFoto.84624bd2.jpg";